// Generated by Melange

import * as Buhta_components__Text from "../../../../packages/components/src/html/Text.js";
import * as StaticAsset from "../../../../packages/util/lib/StaticAsset.js";
import * as JsxRuntime from "react/jsx-runtime";

function ErrorPage(Props) {
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("img", {
                      alt: "error",
                      src: StaticAsset.src("/static/icons/error-triangle.svg")
                    }),
                JsxRuntime.jsx(Buhta_components__Text.H3.make, {
                      className: "mt-6 text-gray-medium",
                      children: "Ошибка загрузки"
                    }),
                JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                      className: "mt-4 text-gray-medium",
                      children: "Что-то пошло не так, обновите страницу."
                    }),
                JsxRuntime.jsx("a", {
                      children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                            className: "text-links",
                            children: "Обратиться в поддержку"
                          }),
                      href: "mailto:hello@buhta.com"
                    }),
                JsxRuntime.jsx("button", {
                      children: JsxRuntime.jsx(Buhta_components__Text.H6.make, {
                            className: "text-white",
                            children: "Обновить страницу"
                          }),
                      className: "bg-links rounded px-4 py-2 mt-6",
                      onClick: (function (param) {
                          window.location.reload();
                        })
                    })
              ],
              className: "flex justify-center items-center h-full flex-col w-full"
            });
}

const make = ErrorPage;

export {
  make ,
}
/* Buhta_components__Text Not a pure module */
